<template>
  <b-form @submit.prevent="save">
    <b-row>
      <b-col md="6" >
        <b-form-group label="Ime i prezime *">
          <b-form-input v-model="userData.name" type="text"></b-form-input>
          <validation-description :show="$v.userData.name.$dirty && $v.userData.name.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group label="Email *">
          <b-form-input v-model="userData.email"  type="text"></b-form-input>
          <validation-description :show="$v.userData.email.$dirty && $v.userData.email.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Rola *">
          <b-form-select v-model="userData.role">
            <option :value="null">-</option>
            <option :key="index" v-for="(role, index) in roles" :value="role.id">
              {{ role.name }}
            </option>
          </b-form-select>
          <validation-description :show="$v.userData.role.$dirty && $v.userData.role.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
    </b-row>
    <template v-if="userData.role && userData.role === CLIENT_ROLE">
      <b-row >
        <hr/>
        <b-col cols="12">
          <h5>
            Klijenti
          </h5>
        </b-col>
        <b-col cols="12" v-if="userData.clients">
          <table class="table -no-padding">
            <tr  :key="`client_${client.id}`" v-for="(client, index) in userData.clients">
              <td style="width: 90%;">
                <SearchClient :value="userData.clients[index]" @input="chooseClient($event, index)"></SearchClient>
                <small class="text-danger" v-if="clientValidationError">
                  Polje je obavezno
                </small>
                <small class="text-danger" v-if="errorClientExist[index]">
                  Ovog klijenta ste vec dodali
                </small>
              </td>
              <td>
                <b-button class="btn btn-link btn-sm btn-del text-info" @click.prevent="deleteClient(index)">
                  <i class="fa fa-trash"></i>
                </b-button>
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col cols="12">
          <button class="btn btn-link ml-0 pl-0" @click.prevent="addClient">Dodaj klijenta</button>
          <p>
            <validation-description :show="$v.userData.clients.$dirty && $v.userData.clients.$invalid">
              {{$t('FIELD_MANDATORY')}} za klijent rolu
            </validation-description>
          </p>
        </b-col>
      </b-row>
    </template>
    <b-row class="mt-3">
      <b-col sm="6" md="6" lg="6">
        <app-button-submit :loading="loading" ></app-button-submit>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
  import AppButtonSubmit from '@/components/app/AppSubmit'
  import ValidationDescription from '@/components/app/form/AppValidationDescription'
  import {getRoleList} from "@/services/role"
  import {required} from 'vuelidate/lib/validators'
  import i18n from '@/locale/index'
  import {createUser} from "@/services/user"
  import {toast} from "@/shared/plugins/toastr"
  import {getErrorMessage} from "@/mixins/error/getErrorMessage"
  import {C_USER_SAVE_BUTTON} from "@/shared/component_permission"
  import {getClientList} from "@/services/client";
  import {CLIENT_ROLE} from "@/shared/constants";
  import SearchClient from "@/components/client/SearchClient";
  export default {
      name: "UserNewForm",
      mixins:[getErrorMessage],
      data() {
        return {
          options_status:[
            {value:1, text: i18n.t('ACTIVE')},
            {value:0, text: i18n.t('NOTACTIVE')}
          ],
          clients: [],
          roles:[],
          userData: {
            name: null,
            email: null,
            clients:[],
            role:null,
            active:1,
          },
          C_USER_SAVE_BUTTON,
          CLIENT_ROLE,
          loading:false,
          disableClient: true,
          clientValidationError: false,
          errorClientExist: {}
        }
      },
      components:{
        ValidationDescription,
        AppButtonSubmit,
        SearchClient
      },
      validations() {
        return !this.disableClient ? {
          userData:{
            name:{required},
            email:{required},
            clients: {},
            role:{required},
          }
        } : {
          userData:{
            name:{required},
            email:{required},
            role:{required},
            clients: {},
          }
        }

      },
      methods: {
        chooseClient(value, index) {
          if(this.userData.clients.find((el) => el.id === value.id)) {
            this.$set(this.errorClientExist, index, true);
            return;
          }
          this.$set(this.errorClientExist, index, false);
          this.$set(this.userData.clients, index, value)
        },
        addClient() {
          this.clientValidationError = false;
          this.userData.clients.push({id: null, name: null});
        },
        deleteClient(index) {
          this.userData.clients.splice(index, 1);
        },
        getData() {
          getRoleList()
             .then(response => {
               this.roles = response.data
            })
          getClientList().then((response) => {
            this.clients = response.data.items
          })
        },
        save() {
          this.$v.userData.$touch()
          if(this.$v.userData.$invalid){
            toast({
              'title': this.$t('VALIDATION_FAILED'),
              'message': null,
              'type': 'error',
              'timeout': 4000
            })
            return
          }
          this.loading = true
          const request = {
            name: this.userData.name,
            email: this.userData.email,
            clients: this.userData.role === CLIENT_ROLE ? this.userData.clients.filter((el) => el.id).map((el) => el.id) : [],
            role: this.userData.role,
            active: this.userData.active,
          }
          createUser(request).then(() => {
            toast({
                title: this.$t('NOTIFICATIONS.SAVE_SUCCESS.TITLE'),
                message: this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
                'type': 'success',
                'timeout': 2000
              })
              this.$store.dispatch('user/actionSearch')
              this.$emit('closePanel', this.editAsidePanel)
          }, error => {
            toast({
              title: this.$t('NOTIFICATIONS.SAVE_ERROR.TITLE'),
              message: this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE', {value: this.getMessages(error)}),
              'type': 'error',
              'timeout': 6000
            })
          }).finally(()=>{
            this.loading = false
          })
        },
      },
    watch: {
      'userData.role': {
        handler(value) {
          if(value === CLIENT_ROLE) {
            this.disableClient = false;
          } else {
            this.disableClient = true;
            this.userData.client = {id: null, name: null}
          }
        }
      }
    },
      async mounted () {
        await this.getData();
      }
    }
</script>

<style scoped>
.table.-no-padding td{
  padding-left: 0;
  padding-right: 0;
}
.btn-del{
  background: none;
  font-size: 18px;
  border: unset;
}
</style>
